export const DEFAULT_BODY_TAG_STYLE = {
  tag: 'body',
  label: 'Body (All Pages)',
  less: 'font-family: Arial; font-size: 14px; line-height: 20px; color: #333;',
} as const;

export const ADDITIONAL_DEFAULT_TAG_STYLES = [
  {tag: 'div', label: 'All Divs', less: ''},
  {tag: 'section', label: 'All Sections', less: ''},
  {tag: 'nav', label: 'All Navigation', less: ''},
  {tag: 'header', label: 'All Headers', less: ''},
  {tag: 'footer', label: 'All Footers', less: ''},
  {tag: 'main', label: 'All Mains', less: ''},
  {tag: 'article', label: 'All Articles', less: ''},
  {tag: 'aside', label: 'All Asides', less: ''},
  {tag: 'address', label: 'All Addresses', less: ''},

  {tag: 'button', label: 'All Buttons', less: ''},
  {tag: 'input', label: 'All Inputs', less: ''},
  {tag: 'textarea', label: 'All Textareas', less: ''},
  {tag: 'select', label: 'All Select Fields', less: ''},

  {tag: 'table', label: 'All Tables', less: ''},
  {tag: 'th', label: 'All Table Headers', less: ''},
  {tag: 'td', label: 'All Table Cells', less: ''},

  {tag: 'dl', label: 'All Definition Lists', less: ''},
  {tag: 'dt', label: 'All Definition Terms', less: ''},
  {tag: 'dd', label: 'All Definition Descriptions', less: ''},
] as const;
/**
 * All sites are created without default tag-based selectors, but they can be added by the user.
 * To make this consistent with the entire style system, each of these are added as a proper StyleBlock, but with a fake=true flag,
 * and only if they don't already exist in the server-side list of StyleBlocks.
 *
 * IMPORTANT: Until we parse site.css in the designer, these styles must match bootflow-* styles exactly!
 */
export const DEFAULT_TAG_STYLES = [
  DEFAULT_BODY_TAG_STYLE,
  {
    tag: 'h1',
    label: 'All H1 Headings',
    less: 'font-size: 38px; line-height: 44px; font-weight: bold; margin-top: 20px; margin-bottom: 10px;',
  },
  {
    tag: 'h2',
    label: 'All H2 Headings',
    less: 'font-size: 32px; line-height: 36px; font-weight: bold; margin-top: 20px; margin-bottom: 10px;',
  },
  {
    tag: 'h3',
    label: 'All H3 Headings',
    less: 'font-size: 24px; line-height: 30px; font-weight: bold; margin-top: 20px; margin-bottom: 10px;',
  },
  {
    tag: 'h4',
    label: 'All H4 Headings',
    less: 'font-size: 18px; line-height: 24px; font-weight: bold; margin-top: 10px; margin-bottom: 10px;',
  },
  {
    tag: 'h5',
    label: 'All H5 Headings',
    less: 'font-size: 14px; line-height: 20px; font-weight: bold; margin-top: 10px; margin-bottom: 10px;',
  },
  {
    tag: 'h6',
    label: 'All H6 Headings',
    less: 'font-size: 12px; line-height: 18px; font-weight: bold; margin-top: 10px; margin-bottom: 10px;',
  },
  {tag: 'p', label: 'All Paragraphs', less: 'margin-bottom: 10px;'},
  {tag: 'a', label: 'All Links', less: 'text-decoration: underline;'},
  {
    tag: 'ul',
    label: 'All Unordered Lists',
    less: 'margin-top: 0px; margin-bottom: 10px; padding-left: 40px;',
  },
  {
    tag: 'ol',
    label: 'All Ordered Lists',
    less: 'margin-top: 0px; margin-bottom: 10px; padding-left: 40px;',
  },
  {tag: 'li', label: 'All List Items', less: ''},
  {
    tag: 'img',
    label: 'All Images',
    less: 'display: inline-block; max-width: 100%;',
  },
  {tag: 'form', label: 'All Forms', less: ''},
  {
    tag: 'label',
    label: 'All Labels',
    less: 'display: block; margin-bottom: 5px; font-weight: bold;',
  },
  {tag: 'strong', label: 'All Bolds', less: 'font-weight: bold;'},
  {tag: 'em', label: 'All Italics', less: 'font-style: italic;'},
  {tag: 'sup', label: 'All Superscripts', less: ''},
  {tag: 'sub', label: 'All Subscripts', less: ''},
  {tag: 'code', label: 'All Code', less: ''},
  {tag: 'pre', label: 'All Pre Tags', less: ''},
  {
    tag: 'blockquote',
    label: 'All Block Quotes',
    less: 'margin-bottom: 10px; padding-top: 10px; padding-bottom: 10px; padding-left: 20px; padding-right: 20px; border-left-style: solid; border-left-width: 5px; border-left-color: #E2E2E2; font-size: 18px; line-height: 22px;',
  },
  {tag: 'figure', label: 'All Figures', less: 'margin-bottom: 10px;'},
  {
    tag: 'figcaption',
    label: 'All Figure Captions',
    less: 'margin-top: 5px; text-align: center;',
  },

  ...ADDITIONAL_DEFAULT_TAG_STYLES,
] as const;

export const TAG_LABEL_MAP: Record<string, string> = Object.fromEntries(
  DEFAULT_TAG_STYLES.map(({tag, label}) => [tag, label])
);

export const DEFAULT_TAG_STYLE_IDS = new Set(
  DEFAULT_TAG_STYLES.map(({tag}) => `default-${tag}`)
);
